import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  label: string;
  value: string;
}

export default function InclusionDetailField({ label, value }: Props) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="caption"
        fontWeight={700}
        color="text.secondary"
        sx={{ display: 'block', letterSpacing: '0.06em', textTransform: 'uppercase' }}
      >
        {label}
      </Typography>
      <Typography variant="body2" sx={{ overflowWrap: 'break-word' }}>
        {value}
      </Typography>
    </Box>
  );
}
